import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const quotes = [
  {
    text: "Leaders have an obligation to help their people learn, develop and apply AI to transform how work gets done.",
    context: "On AI Leadership & Workforce Transformation",
  },
];

export default function QuoteSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section data-testid="quote-section" ref={ref} className="py-32 md:py-48 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#C4963B]/[0.02] to-transparent pointer-events-none" />
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.div
          className="max-w-4xl mx-auto md:mx-0 md:ml-[8%]"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="text-[#C4963B]/20 text-8xl md:text-[9rem] font-['Cormorant_Garamond'] leading-none select-none">
            &ldquo;
          </span>
          <blockquote className="font-['Cormorant_Garamond'] text-2xl md:text-4xl lg:text-[2.8rem] italic leading-snug text-[#F9F6F0] -mt-10 md:-mt-16">
            Leaders have an obligation to help their people learn, develop and
            apply AI to transform how work gets done.
          </blockquote>
          <div className="mt-10 flex items-center gap-4">
            <div className="w-12 h-px bg-[#C4963B]" />
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-[#E8E6E1]/50 font-medium">
                Joe Atkinson
              </p>
              <p className="text-[10px] text-[#E8E6E1]/25 tracking-[0.15em] mt-0.5">
                Global Chief AI Officer · PwC
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
